import { useAuthQuery } from '#lib/hooks/use-auth-query.js';
import { jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';

async function fetchCreatePaymentIntent(data) {
    const headers = await getAuthHeader();
    const response = await fetch(`${API_URL}/p/payment`, {
        method: 'POST',
        headers: {
            ...jsonHeaders,
            ...headers
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}

export function usePayment(options) {
    return useMutation({
        mutationFn: fetchCreatePaymentIntent,
        onError: (error) => {
            toast.error(error.message);
        },
        ...options
    });
}

async function fetchPack(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/pack`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

export function usePack() {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['pack'],
        queryFn: fetchPack,
        staleTime: Infinity,
        keepPreviousData: true
    });

    return {
        data: data?.results,
        ...queryProps
    };
}

async function fetchPurchases(url) {
    const authHeaders = await getAuthHeader();
    const response = await fetch(`${API_URL}/p/${url}`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

export function usePurchases() {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['purchase'],
        queryFn: () => fetchPurchases('purchases'),
        staleTime: Infinity,
        keepPreviousData: true
    });

    return {
        data: data?.results,
        ...queryProps
    };
}

export function useResources() {
    const { ...queryProps } = useAuthQuery({
        queryKey: ['credits'],
        queryFn: () => fetchPurchases('credits')
    });

    return {
        ...queryProps
    };
}
